export function formatId(id: number): string {
  return '#' + ('00' + id).slice(-6);
}
